export function TextTo({ value_metric, value_imperial}){
    if (window.sessionStorage.getItem('UnitConversion') === "IMPERIAL") {
        return (
            value_imperial
        );
    }
    return (
        value_metric
    );
}

export function AddUnit({value, unit_metric, unit_imperial}){
    if (window.sessionStorage.getItem('UnitConversion') === "IMPERIAL") {
        return (
            value + unit_imperial
        );
    }
    return (
        value + unit_metric
    );
}

export function AddSymbol({check}){
    if (window.sessionStorage.getItem('UnitConversion') === "IMPERIAL" && check) {
        return "#"
    }
    return "";
}